export enum EAction {
    SetStatus = '@agreements/status/set',
    SetAgreements = '@agreements/list/set',
}
